<template>
    <div id="app">
        <router-view></router-view>
        <vue-snotify></vue-snotify>
        <portal-target name="modals"></portal-target>
    </div>
</template>
<script>
import Vue from "vue";
import BootstrapVue from 'bootstrap-vue';

Vue.use(BootstrapVue);
Vue.config.productionTip = false;

export default {
    name: 'app',
}
</script>
<style src="bootstrap-vue/dist/bootstrap-vue.css"></style>
<style src="../sass/themify-icons/themify-icons.css"></style>
